<template>
  <v-layout row wrap>
    <v-container>
      <v-layout class="mb-2">
        <v-flex>
          <template v-for="(category, index) in categories">
            <v-item :key="index">
              <v-chip v-if="categoryId === category.id"
                      class="subheading font-weight-medium" :color="category.color + ' lighten-3'"
                      @click="gotoCategory(category.id)" text-color="white">
                {{ category.name }}
              </v-chip>
              <v-chip v-else class="subheading font-weight-medium"
                      :color="category.color + ' lighten-3'" outline
                      @click="gotoCategory(category.id)">{{ category.name }}</v-chip>
            </v-item>
          </template>
          <v-btn v-if="user" fab dark small outline color="grey" @click="openCategoryDialog()"
                 style="height: 36px;width: 36px;">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <template v-for="(topic, i) in topics">
          <TopicCard :key="i" :topic="topic"></TopicCard>
        </template>

        <v-flex xs12 sm3 v-if="isCommunityJoined">
          <v-card color="grey" class="black--text pa-1" height="224px">
            <v-layout align-center justify-center row fill-height>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn round color="teal" dark
                         slot="activator" @click="topicDialog = true">Add Topic Card</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-dialog v-model="picker" :max-width="338">
          <v-card>
            <Picker set="google" :sheetSize="32"/>
          </v-card>
        </v-dialog>

        <v-dialog v-model="topicDialog" fullscreen hide-overlay
                  transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="teal">
              <v-btn icon dark @click="topicDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>New Topic</v-toolbar-title>
            </v-toolbar>
            <v-container>
              <v-layout wrap>
                <v-flex xs12 sm6 offset-sm3 text-xs-center>
                  <v-checkbox v-model="isPublic"
                              color="teal" label="Public - only for now" disabled></v-checkbox>
                  <v-checkbox v-model="isPinned"
                              color="teal" label="Pinned"></v-checkbox>
                  <v-text-field v-model="topicTitle" label="Topic Title"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 offset-sm3 class="mt-3">
                  <h3>Topic About</h3>
                  <tiptap-editor @onBlur="editContent"></tiptap-editor>
                </v-flex>
                <v-flex xs12 sm6 offset-sm3 text-xs-center>
                  <v-btn :loading="isTopicCardCreating" :disabled="isTopicCardCreating"
                         color="teal white--text" @click="createTopicCard()">
                    Add Topic Card
                    <span slot="loader">Loading...</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import firebase from 'firebase';
import { Emoji, Picker } from 'emoji-mart-vue';
import TiptapEditor from '@/components/TiptapEditor.vue';
import TopicCard from '@/components/topic/TopicCard.vue';

export default {
  name: 'CategorySpace',
  components: {
    TopicCard,
    TiptapEditor,
    Emoji,
    Picker,
  },
  props: {
    user: Object,
    communityId: String,
    isCommunityJoined: Boolean,
    categories: Array,
  },
  data() {
    return {
      categoryId: '',
      color: '',
      topics: [],
      topicDialog: false,
      isTopicCardCreating: false,
      topicTitle: '',
      topicAbout: '',
      isPublic: true,
      isPinned: false,
    };
  },
  created() {
    this.categoryId = this.$route.params.categoryId;
    this.getTopics();
  },
  beforeRouteUpdate(to, from, next) {
    if (from.params.categoryId === 'public') {
      this.categoryId = to.params.categoryId;
      this.topics = this.topics.filter(topic => topic.categoryRef.id === to.params.categoryId);
    } else if (to.params.categoryId !== from.params.categoryId) {
      this.categoryId = to.params.categoryId;
      this.getTopics();
    }

    next();
  },
  methods: {
    gotoCategory(categoryId) {
      this.$router.push(`/c/${this.communityId}/category/${categoryId}`);
    },
    gotoTopic(topicId) {
      this.$router.push(`/c/${this.communityId}/topic/${topicId}`);
    },
    openCategoryDialog() {
      this.$emit('openCategoryDialog');
    },
    getTopics() {
      this.topics = [];

      let topicsRef;
      if (this.categoryId === 'public') {
        topicsRef = firebase.firestore().collection(`communities/${this.communityId}/topics`).orderBy('createdAt', 'desc');
      } else {
        topicsRef = firebase.firestore().collection(`communities/${this.communityId}/topics`)
          .where('categoryRef', '==', firebase.firestore().doc(`communities/${this.communityId}/categories/${this.categoryId}`))
          .orderBy('createdAt', 'desc');
      }

      topicsRef.get().then((querySnapshot) => {
        if (!querySnapshot.empty) {
          querySnapshot.forEach((topicDoc) => {
            this.addTopicDoc(topicDoc);
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    addTopicDoc(topicDoc) {
      const topic = {
        id: topicDoc.id,
        communityId: this.communityId,
        title: topicDoc.data().title,
        about: topicDoc.data().about,
        color: topicDoc.data().color,
        isPublic: topicDoc.data().isPublic,
        isPinned: topicDoc.data().isPinned,
        userRef: topicDoc.data().userRef,
        categoryRef: topicDoc.data().categoryRef,
        likes: topicDoc.data().likes,
        isLiked: topicDoc.data().likes
          ? topicDoc.data().likes.filter(like => like.uid === this.user.uid).length : false,
        shares: topicDoc.data().shares,
        commentNum: topicDoc.data().commentNum,
        createdAt: topicDoc.data().createdAt,
      }

      if (topic.isPinned) {
        this.topics.unshift(topic);
      } else {
        this.topics.push(topic);
      }
    },
    editContent(content) {
      this.topicAbout = content;
    },
    createTopicCard() {
      this.isTopicCardCreating = true;
      const topic = {
        title: this.topicTitle,
        about: this.topicAbout,
        color: this.categories.filter(category => category.id === this.categoryId)[0].color,
        isPublic: this.isPublic,
        isPinned: this.isPinned,
        userRef: firebase.firestore().doc(`users/${this.user.uid}`),
        categoryRef: firebase.firestore().doc(`communities/${this.communityId}/categories/${this.categoryId}`),
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firebase.firestore().collection(`communities/${this.communityId}/topics`).add(topic)
        .then((topicRef) => {
          this.$router.push(`/c/${this.communityId}/topic/${topicRef.id}?thumbnail=true`);
        })
        .catch(error => console.error(error));
      console.log(this.topicAbout);
    },
  },
};
</script>
